export default "__VITE_ASSET__46af995f__"